import {Component, input, output} from "@angular/core";
import {DxDateBoxModule} from "devextreme-angular";

@Component({
    selector: 'yo-time-picker',
    templateUrl: './time-picker.component.html',
    standalone: true,
    imports: [DxDateBoxModule]
})
export class TimePickerComponent {

  readonly value = input<Date>();
  readonly disabled = input<boolean>(false);
  readonly width = input<number>(80);
  readonly popupTitle = input<string>();

  readonly onValueChange = output<Date>();

  onTimeSelected = ($event) => {
    this.onValueChange.emit($event.value);
  }
}
